import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EnterpriseSection = () => {
  const enterpriseFeatures = [
    "Custom pricing based on your needs",
    "Dedicated account manager",
    "Priority 24/7 support",
    "Custom integrations and API access",
    "Advanced security and compliance",
    "Unlimited users and locations",
    "Custom training and onboarding",
    "White-label options available"
  ];

  return (
    <div className="rounded-2xl border border-border bg-gradient-to-br from-primary/5 to-secondary/5 p-6 md:p-8 lg:p-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 mb-4">
            <Icon name="Building2" size={18} color="var(--color-primary)" strokeWidth={2} />
            <span className="font-body text-sm font-medium text-primary">
              Enterprise Solution
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Need a Custom Solution?
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground mb-6">
            For large retail chains, franchises, or businesses with unique requirements, we offer tailored enterprise solutions with flexible pricing and dedicated support.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {enterpriseFeatures?.map((feature, index) => (
              <div key={index} className="flex items-start gap-2">
                <Icon
                  name="Check"
                  size={20}
                  color="var(--color-primary)"
                  strokeWidth={2}
                  className="flex-shrink-0 mt-0.5"
                />
                <span className="font-body text-sm md:text-base text-foreground">
                  {feature}
                </span>
              </div>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="/contact" className="flex-1 sm:flex-initial">
              <Button variant="default" size="lg" iconName="Mail" iconPosition="left">
                Contact Sales
              </Button>
            </a>
            <a href="https://app.cultaz.com" target="_blank" rel="noopener noreferrer" className="flex-1 sm:flex-initial">
              <Button variant="outline" size="lg" iconName="Phone" iconPosition="left">
                Schedule Demo
              </Button>
            </a>
          </div>
        </div>

        <div className="relative">
          <div className="rounded-2xl border border-border bg-card p-6 md:p-8 shadow-purple-lg">
            <div className="space-y-6">
              <div className="flex items-center justify-between pb-4 border-b border-border">
                <span className="font-body text-sm text-muted-foreground">
                  Monthly Volume
                </span>
                <span className="font-heading text-lg font-bold text-foreground">
                  Custom
                </span>
              </div>
              <div className="flex items-center justify-between pb-4 border-b border-border">
                <span className="font-body text-sm text-muted-foreground">
                  Number of Stores
                </span>
                <span className="font-heading text-lg font-bold text-foreground">
                  Unlimited
                </span>
              </div>
              <div className="flex items-center justify-between pb-4 border-b border-border">
                <span className="font-body text-sm text-muted-foreground">
                  User Accounts
                </span>
                <span className="font-heading text-lg font-bold text-foreground">
                  Unlimited
                </span>
              </div>
              <div className="flex items-center justify-between pb-4 border-b border-border">
                <span className="font-body text-sm text-muted-foreground">
                  Support Level
                </span>
                <span className="font-heading text-lg font-bold text-foreground">
                  Priority 24/7
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="font-body text-sm text-muted-foreground">
                  Implementation
                </span>
                <span className="font-heading text-lg font-bold text-foreground">
                  Dedicated Team
                </span>
              </div>
            </div>
          </div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-primary/10 rounded-full blur-3xl" />
          <div className="absolute -top-4 -left-4 w-32 h-32 bg-secondary/10 rounded-full blur-3xl" />
        </div>
      </div>
    </div>
  );
};

export default EnterpriseSection;